export const uploadAbortRef: {
  current: { [key: string]: undefined | (() => void) };
} = {
  current: {},
};
